import { useEffect } from 'react';
import { type BaseItem } from '@algolia/autocomplete-core';

import styles from './AutocompleteDropdown.module.css';

export interface Facet extends BaseItem {
  label: string;
  value: string;
}

export function AutocompleteDropdown({
  activeIndex,
  handleCloseDropdown,
  onSelect,
  results,
}: {
  activeIndex: number;
  handleCloseDropdown: () => void;
  onSelect: (item: string) => void;
  results: string[];
}) {
  const handleClick = (item: string) => {
    onSelect(item);
    handleCloseDropdown();
  };

  useEffect(() => {
    const activeElement = document.querySelector(`li[data-index="${activeIndex}"]`);
    if (activeElement) {
      activeElement.scrollIntoView({ block: 'nearest' });
    }
  }, [activeIndex]);

  return (
    <ul className={styles.dropdown}>
      {results.map((item, index) => (
        <li
          className={`${styles.dropdownItem} ${index === activeIndex ? styles.dropdownItemActive : ''}`}
          data-index={index}
          key={item}
          onClick={() => handleClick(item)}
        >
          {item}
        </li>
      ))}
    </ul>
  );
}
